<template>
  <el-dialog
    v-if="parent_data.show_dialog"
    :title="title"
    :visible.sync="parent_data.show_dialog"
    :before-close="closeBox"
    :close-on-click-modal="false"
  >
    <div class="nodatawork">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="150px"
        style="padding-left: 5%"
      >
        <el-form-item label="公告标题:" prop="title" required>
          <el-input v-model="form.title" placeholder="公告标题"></el-input>
        </el-form-item>

        <el-form-item label="公告内容:" prop="content" required>
          <vue-editor
            v-model="form.content"
            :config="uploadConfig"
            :upload-handler="uploadHandler"
          ></vue-editor>
        </el-form-item>
        <span>发布规则</span>

        <el-form-item>
          <el-checkbox
            v-model="form.rule"
            style="float: left; margin-right: 20px"
            true-label="1"
            false-label="2"
            >指定商家</el-checkbox
          >
          <el-select
            v-model="supply"
            style="float: left; margin-right: 20px"
            placeholder="输入商家,至少3个字符"
            :remote-method="fetchSupply"
            remote
            filterable
            :disabled="form.rule == 2"
            @change="add_supply"
          >
            <el-option
              v-for="(item, index) in supplyOption"
              :key="item.supply_id"
              :value="item.supply_id"
              :label="item.supply_name"
            ></el-option>
          </el-select>
          <el-upload
            ref="upload"
            style="float: left"
            name="file"
            :action="action"
            :limit="1"
            accept=".xls,.xlsx,.csv"
            :file-list="filelist"
            :on-success="importFile"
            :auto-upload="true"
            with-credentials
          >
            <el-button
              slot="trigger"
              size="mini"
              type="primary"
              :disabled="form.rule == 2"
              >导入商家</el-button
            >
            <div slot="tip" class="el-upload__tip">
              注意：导入文件，则以导入为准，手动选择无效
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-tag
            v-for="tag in select_supply"
            v-if="form.rule == 1"
            :key="tag.supply_id"
            closable
            :type="tag.supply_id"
            @close="delete_supply(tag)"
          >
            {{ tag.supply_name }}
          </el-tag>
        </el-form-item>

        <el-form-item label="是否标杆商家:">
          <el-select
            v-model="form.is_benchmarking"
            placeholder="是否标杆商家"
            :disabled="form.rule == 1"
          >
            <el-option value="2" label="全部"></el-option>
            <el-option value="1" label="是"></el-option>
            <el-option value="0" label="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商家等级:">
          <el-select
            v-model="form.supply_level"
            multiple
            placeholder="商家等级"
            :disabled="form.rule == 1"
          >
            <el-option value="S" label="S"></el-option>
            <el-option value="A" label="A"></el-option>
            <el-option value="B" label="B"></el-option>
            <el-option value="C" label="C"></el-option>
            <el-option value="D" label="D"></el-option>
            <el-option value="E" label="E"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          v-if="form.publish_status == 0"
          label="立即发布:"
          class="redItem"
          prop="mobile"
        >
          <template>
            <el-radio v-model="form.publish_now" label="1">是</el-radio>
            <el-radio v-model="form.publish_now" label="2">否</el-radio>
          </template>
        </el-form-item>

        <el-form-item v-if="form.publish_now == 2" label="预约发布时间:">
          <el-date-picker
            v-model="form.publish_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item v-if="form.publish_status == 1" label="发布时间:">
          <el-date-picker
            v-model="form.publish_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item v-if="form.publish_status == 0">
          <el-button @click="closeBox">取消</el-button>
          <el-button type="primary" @click="submitData">确认</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import VueEditor from "yimo-vue-editor";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: {
    VueEditor,
  },
  props: {
    parent_data: Object,
    supply_notice_id: String,
  },
  data() {
    return {
      uploadConfig: {
        uploadImgUrl: `${apiBaseURL}/erp/common/erpUploadFile`,
        withCredentials: true,
      },
      baseUrl: "/erp/Supply/AddNotice",
      form: {
        publish_now: "1",
        rule: "2",
        is_benchmarking: "2",
        supply_ids: [],
        title: "",
        content: "",
        publish_time: "",
        publish_status: 0,
        supply_file: "",
      },
      fullscreenLoading: false,
      rules: {
        title: [{ required: true, message: "请输入公告标题" }],
        content: [{ required: true, message: "请输入公告内容" }],
      },
      title: "创建消息公告",
      supplyOption: [],
      select_supply: [],
      filelist: [],
      supply: "",
      action: `${apiBaseURL}/erp/Common/uploadFileToLocal`,
    };
  },
  created() {},
  destroyed() {},
  methods: {
    importFile(res, fileList) {
      if (res.code !== 200) {
        this.$message.e(res.msg);
      } else {
        this.form.supply_file = res.data.file;
      }
    },
    uploadHandler(type, res) {
      console.log("🚀 : uploadHandler : type:", type);
      console.log("🚀 : uploadHandler : res:", res);
      const result = JSON.parse(res);
      if (result.code !== 200) {
        return this.$message.error(`${result.msg}(2MB以内)`);
      }
      return result.data.origin_files[0];
    },
    initForm() {
      if (this.supply_notice_id > 0) {
        this.baseUrl = "/erp/Supply/editNotice";
        this.$http
          .post("/erp/Supply/beforeEditNotice", {
            supply_notice_id: this.supply_notice_id,
          })
          .then((result) => {
            if (result.data.code != 200) {
              return this.$message.e(result.data.msg);
            }
            this.form = result.data.data.notice;
            this.select_supply = result.data.data.supply;
            if (this.form.publish_status == 1) {
              this.title = "消息公告详情";
            } else {
              this.title = "编辑消息公告";
            }
          })
          .catch((err) => {});
      } else {
        this.baseUrl = "/erp/Supply/AddNotice";
        this.supplyOption = [];
        this.select_supply = [];
        this.form = {
          publish_now: "1",
          rule: "2",
          is_benchmarking: "2",
          supply_ids: [],
          title: "",
          content: "",
          publish_time: "",
          publish_status: 0,
        };
        this.title = "创建消息公告";
      }
    },
    add_supply(val) {
      this.supplyOption.forEach((v) => {
        if (v.supply_id == val) {
          if (!this.form.supply_ids.includes(val)) {
            this.select_supply.push({
              supply_id: v.supply_id,
              supply_name: v.supply_name,
            });
            this.form.supply_ids.push(v.supply_id);
          }
        }
      });
    },
    delete_supply(val) {
      this.select_supply.splice(this.select_supply.indexOf(val), 1);
      this.form.supply_ids.splice(
        this.form.supply_ids.indexOf(val.supply_id),
        1
      );
    },
    submitData() {
      this.$confirm("请确认发布公告信息无误，是否确认发布", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.fullscreenLoading = true;
          this.$http
            .post(this.baseUrl, this.form)
            .then((result) => {
              this.fullscreenLoading = false;
              if (result.data.code != 200) {
                return this.$message.e(result.data.msg);
              }
              this.$message.success(result.data.msg);
              this.closeBox();
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    closeBox() {
      this.supplyOption = [];
      this.select_supply = [];
      this.supply = "";
      // this.$refs.form.resetFields();
      this.parent_data.show_dialog = false;
      this.$parent.fetchData(true);
    },
    fetchSupply(e) {
      if (typeof e === "string" && e.length > 2) {
        this.$http
          .post("/erp/Common/selectSupply", { supply_name: e })
          .then((res) => {
            if (res.data.code != 200) {
              return this.$message.error(res.data.msg);
            }
            this.supplyOption = res.data.data;
          });
      }
    },
  },
};
</script>

<style>
.redItem .el-form-item__label {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/components/EditNotice.vue